// Phone/fax formatting used everywhere in the app: (438) 664-0000.
//
// formatPhone() is the as-you-type mask for inputs: keeps digits only and
// builds up the (xxx) xxx-xxxx shape. displayPhone() is for read-only views
// (tables, summaries, dropdown labels): it reformats anything that is a
// North American 10-digit number, and leaves anything else (international
// numbers, notes typed into the field) exactly as stored rather than
// mangling it.

// A leading country code 1 on an 11-digit number is dropped, so pasting
// "+1 438 664 0000" gives (438) 664-0000. NANP area codes never start with
// 1, so this can't eat a real digit.
function nationalDigits(value) {
  let digits = String(value ?? '').replace(/\D/g, '');
  if (digits.length === 11 && digits[0] === '1') digits = digits.slice(1);
  return digits;
}

export function formatPhone(value) {
  const digits = nationalDigits(value).slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function displayPhone(value) {
  if (value === null || value === undefined || value === '') return '';
  return nationalDigits(value).length === 10 ? formatPhone(value) : String(value);
}
